// utils/index.js
// 处理树节点 选中父 子全部选上
export function checkedChildren(val) {
    for (const item of val) {
      item.checked = true
      if (item.children && item.children.length !== 0) {
        checkedChildren(item.children)
      }
    }
    return val
  }
  // 处理树节点 取消父 子全部取消
  export function cancelChildren(val) {
    for (const item of val) {
      item.checked = false
      if (item.children && item.children.length !== 0) {
        cancelChildren(item.children)
      }
    }
    return val
  }